import { FileRefQuery } from './../../../shared/queries/file-ref-query';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Output, EventEmitter, ViewChild, ElementRef, Input, NgZone } from '@angular/core';

import { FileBrowserComponent } from './../+file-manager/file-browser';

import { ImageSizeError } from '@shared/errors';
import { Size, FileRef } from '@shared/data';
export interface InputImageEvent {
  file: File;
  data: any;
}

@Component({
  selector: 'image-browser',
  styles: [require('./image-browser.component.scss')],
  template: require('./image-browser.component.html')
})
export class ImageBrowserComponent {
  @Input()
  public width: number;

  @Input()
  public height: number;

  @Input()
  public size: Size;

  @Input()
  public placeholderWidth: number;

  @Input()
  public placeholderHeight: number;

  @Input()
  public fontSize: number;

  @Input()
  public url: string;

  @Input()
  public src: string = '/assets/img/upload.png';

  @Output()
  public imageChange: EventEmitter<InputImageEvent>;

  @Output()
  public imageSelect: EventEmitter<FileRef>;

  @Output()
  public error: EventEmitter<Parse.Error>;

  @ViewChild('inputFile')
  public inputFile: ElementRef;

  public imageUrl: string;

  constructor(private modalService: NgbModal, private zone: NgZone) {
    this.error = new EventEmitter();
    this.imageChange = new EventEmitter();
    this.imageSelect = new EventEmitter();
  }

  public onBrowse() {
    let win: Window = this.popupWindow('./admin/file-manager');

    win.addEventListener('selectFile', (evt: CustomEvent) => {
      this.zone.run(() => {
        let image = new FileRef();

        image.id = evt.detail.id;

        this.imageUrl = evt.detail.url;
        this.imageSelect.emit(image);
      });
    });
  }

  public selectFile() {
    this.inputFile.nativeElement.click();
  }

  public onFileSelect($event) {
    let reader = new FileReader();
    let image = new Image();
    let file: File = event.srcElement['files'][0];

    image.onload = () => {
      if (this.limitSize) {
        let widthDiff = Math.abs( image.width - this.actualWidth );
        let heightDiff = Math.abs( image.height - this.actualHeight );

        if (widthDiff > 10 || heightDiff > 10) {
          this.error.emit(new ImageSizeError());
          return;
        }
      }

      reader.onload = (e) => {
        let data = e.target['result'];

        this.imageUrl = data;
        this.imageChange.emit({file, data});
      };

      reader.readAsDataURL(file);
    };

    image.src = URL.createObjectURL(file);
  }

  public get actualWidth(): number {
    return this.size ? this.size.w : this.width;
  }

  public get actualHeight(): number {
    return this.size ? this.size.h : this.height;
  }

  public get limitSize() {
    return this.actualHeight != undefined && this.actualWidth != undefined;
  }

  private popupWindow(url:string, title: string="", w: number=1200, h: number=800) {
    let y = window.top.outerHeight / 2 + window.top.screenY - ( h / 2)
    let x = window.top.outerWidth / 2 + window.top.screenX - ( w / 2)

    return window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+y+', left='+x);
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/image-browser/image-browser.component.ts